import { render, staticRenderFns } from "./WidgetAdd.vue?vue&type=template&id=391ca590&"
import script from "./WidgetAdd.vue?vue&type=script&lang=js&"
export * from "./WidgetAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports